module.exports = __webpack_public_path__ + "toggleOn.9ec5abfe.png";